const SendAlertStatus = ({ gastverbruik }) => {
  // Return early als er geen sendalert data is
  if (!gastverbruik || !gastverbruik.sendalert || gastverbruik.sendalert.length === 0) {
    return null;
  }

  // Sorteer alerts op percentage (oplopend)
  const sortedAlerts = [...gastverbruik.sendalert].sort((a, b) => a.waarde - b.waarde);

  return (
    <div className="box box-default">
      <div className="box-header with-border">
        <h3 className="box-title">
          <i className="fas fa-bell"></i> Email Alert Status
        </h3>
        <div className="box-tools pull-right">
          <span className="badge badge-info">
            {sortedAlerts.filter(alert => alert.send).length} van {sortedAlerts.length} verzonden
          </span>
        </div>
      </div>
      <div className="box-body">
        <table className="table table-condensed table-striped">
          <thead>
            <tr>
              <th style={{ width: "20%" }}>Percentage</th>
              <th style={{ width: "25%" }}>Status</th>
              <th style={{ width: "35%" }}>Type</th>
              <th style={{ width: "20%" }}>Actie</th>
            </tr>
          </thead>
          <tbody>
            {sortedAlerts.map((alert, index) => {
              const isSent = alert.send;
              
              // Bepaal type beschrijving
              let alertType, alertClass;
              if (alert.waarde === 100) {
                alertType = "Tegoed op";
                alertClass = "danger";
              } else if (alert.waarde >= 90) {
                alertType = "Kritieke waarschuwing";
                alertClass = "warning";
              } else if (alert.waarde >= 80) {
                alertType = "Waarschuwing";
                alertClass = "warning";
              } else {
                alertType = "Informatie";
                alertClass = "info";
              }

              return (
                <tr key={index}>
                  <td>
                    <span className={`label label-${alertClass}`}>
                      {alert.waarde}%
                    </span>
                  </td>
                  <td>
                    {isSent ? (
                      <span className="label label-success">
                        <i className="fas fa-check"></i> Verzonden
                      </span>
                    ) : (
                      <span className="label label-default">
                        <i className="fas fa-clock"></i> Wachtend
                      </span>
                    )}
                  </td>
                  <td>
                    <span className="text-muted">{alertType}</span>
                  </td>
                  <td>
                    {isSent ? (
                      <small className="text-success">
                        <i className="fas fa-envelope"></i> Email verstuurd
                      </small>
                    ) : (
                      <small className="text-muted">
                        <i className="fas fa-hourglass-half"></i> Wacht op trigger
                      </small>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SendAlertStatus;